import React, { useState, useEffect, useMemo, useRef } from "react";
import DataServiceSQL from "../../DataService/DataServiceSQL";
import GatewayFunctionsGetter from '../../Controller/getSQLGatewayFunctions.js';
import DeviceFunctionsGetter from '../../Controller/getSQLDeviceFunctions.js';
import { useTable } from "react-table";
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import AddGateway from './AddGateway.js';
import Gateway from './Gateway.js';
import DeleteObject from '../Common/DeleteObject.js';
import GatewayOrder from '../Common/GatewayOrder.js'
import {FormattedMessage} from 'react-intl';
import { Icon } from 'semantic-ui-react';

const GatewayList = (props) => {
  const [gateway_list, setGatewayList] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [display_Add_Gateway_Popup, setAddGatewayPopup] = useState(false);
  const [display_Delete_Gateway_Popup, setDeleteGatewayPopup] = useState(false);
  const [display_Edit_Gateway_Popup, setEditGatewayPopup] = useState(false); 
  const [display_Send_Gateway_Order_Popup, setGatewayOrderPopup] = useState(false);  
  const [current_Id_Gtw, setCurrentGatewayID] = useState("");
  const [current_Name_Gtw, setCurrentGatewayName] = useState("");
  const [type_Of_Gtw_Order, setTypeOfGatewayOrder] = useState("");  

  const gatewayRef = useRef();
  gatewayRef.current = gateway_list;

  useEffect(() => {
    retrieveGatewayList();
  },
  //eslint-disable-next-line 
  []);

  const onChangeSearchName = (e) => {
    const searchName = e.target.value;
    setSearchName(searchName);
  };

  const retrieveGatewayList = async () => {
    let local_all_List = [];
    let local_gateway_List = [];
    let local_device_List = [];

    // get gateway list
    local_all_List = await DeviceFunctionsGetter.get_device_list(props.structure_Id);

    if (!local_all_List || local_all_List === "none") {
      setGatewayList([]);
      props.setGatewayList([]);
      return;
    }

    local_gateway_List = GatewayFunctionsGetter.convert_fhir_gateway(local_all_List);
    if((local_gateway_List !== "none")&&(local_gateway_List !== undefined)&&(local_gateway_List.length >= 0)){ 
      // Change FK_tucky1, FK_tucky2, FK_tucky3, FK_tucky4 from number to device sn
      local_device_List = DeviceFunctionsGetter.convert_fhir_devices(local_all_List);

      if((local_device_List !== "none")&&(local_device_List.length >= 0)){ 

        local_gateway_List.forEach(item =>{

          const result = local_device_List.find(device => device.id_device === item.FK_Tucky1);
          if(result !== undefined) {item.FK_Tucky1 = result.type + " " + result.sn;}    
          const result2 = local_device_List.find(device => device.id_device === item.FK_Tucky2);
          if(result2 !== undefined) {item.FK_Tucky2 = result2.type + " " + result2.sn;}  
          const result3 = local_device_List.find(device => device.id_device === item.FK_Tucky3);
          if(result3 !== undefined) {item.FK_Tucky3 = result3.type + " " + result3.sn;}   
          const result4 = local_device_List.find(device => device.id_device === item.FK_Tucky4);
          if(result4 !== undefined) {item.FK_Tucky4 = result4.type + " " + result4.sn;}             
        })
        // Set gateway_list to be displayed in table
      }
      setGatewayList(local_gateway_List);      
      props.setGatewayList(local_gateway_List);
    }
    else{
      setGatewayList([]);
      props.setGatewayList([]);
    }
  };

  const findGatewayByName = () => {
    // TEMP: should be changed by getter function
    if(searchName.length !== 0){
      DataServiceSQL.findDeviceReq_fhir("serialNumber", searchName)
      .then((response) => {
        let local_gateway_List = GatewayFunctionsGetter.convert_fhir_gateway(response.data);
        setGatewayList(local_gateway_List);
        props.setGatewayList(local_gateway_List);
      })
      .catch((e) => {
        console.log(e);
      });
    }
    else{
      retrieveGatewayList();
    }
  };

  const editOrDeleteGateway = (rowIndex, action) => {
   // console.log("Edit Or Delete Gateway");
    setCurrentGatewayID(gatewayRef.current[rowIndex].id_gw);
    setCurrentGatewayName(gatewayRef.current[rowIndex].gw_name);    

    if(action === "edit"){
      manageEditGatewayDisplay()
    }
    else if(action === "delete"){   
      manageDeleteGatewayDisplay()
    } 
  };

  const sendGatewayOrder = (rowIndex, type) => {

  //  console.log("Gateway order: new " + type);
    setTypeOfGatewayOrder(type);
    setCurrentGatewayID(gatewayRef.current[rowIndex].id_gw);
    setCurrentGatewayName(gatewayRef.current[rowIndex].gw_name);
    manageGatewayOrderDisplay();
  }

  // turn on-off popup
  const manageAddNewGatewayDisplay = () => {
    setAddGatewayPopup(!display_Add_Gateway_Popup);
  };

  const manageEditGatewayDisplay = () => {
    setEditGatewayPopup(!display_Edit_Gateway_Popup);
  };

  // turn on-off popup
  const manageDeleteGatewayDisplay = () => {
    setDeleteGatewayPopup(!display_Delete_Gateway_Popup);
  };

  // turn on-off popup
  const manageGatewayOrderDisplay = () => {
    setGatewayOrderPopup(!display_Send_Gateway_Order_Popup);   
  };

  const closeAfterAdding = () => {
    retrieveGatewayList();
    manageAddNewGatewayDisplay();
  };

  const closeAfterEdition = () => {
    retrieveGatewayList();
    manageEditGatewayDisplay();
  };

  const closeAfterDeletion = () => {
    retrieveGatewayList();
    manageDeleteGatewayDisplay();
  };

  const closeAfterOrder = () => {
    retrieveGatewayList();
    manageGatewayOrderDisplay();    
  };

/*
 const clearGatewayErrorLog = (rowIndex) => {
    DataServiceSQL.clearGatewayErrorLog(props.structure_Id, gatewayRef.current[rowIndex].id_gw);
    retrieveGatewayList();    
  };
*/
  let columns;
  if (props.accountInformation.readOnly === true) {
    columns = useMemo(
      () => [
        { Header: "Numéro série", accessor: "gw_name" },
        { Header: "Surnom", accessor: "nickname" },
        { Header: "Active", accessor: "online" },
        { Header: "Durée", accessor: "uptime" },
        { Header: "Wifi", accessor: "wifi_rssi" },
        { Header: "Logiciel", accessor: "fw_version_cur" },
        { Header: "device1", accessor: "FK_Tucky1" },
        { Header: "device2", accessor: "FK_Tucky2" },
        { Header: "device3", accessor: "FK_Tucky3" },
        { Header: "device4", accessor: "FK_Tucky4" },
      ],
      //eslint-disable-next-line
      []
    );
  }
  else {
    columns = useMemo(
    () => [
      { Header: "Numéro série", accessor: "gw_name" },
      { Header: "Surnom", accessor: "nickname" },
      { Header: "Active", accessor: "online" },
      { Header: "Durée", accessor: "uptime" },
      { Header: "Wifi", accessor: "wifi_rssi" },
      { Header: "Logiciel", accessor: "fw_version_cur" },
      { Header: "device1", accessor: "FK_Tucky1" },
      { Header: "device2", accessor: "FK_Tucky2" },
      { Header: "device3", accessor: "FK_Tucky3" },
      { Header: "device4", accessor: "FK_Tucky4" },
      {
        Header: "Action",
        accessor: "actions",
        Cell: (props) => {
          const rowIdx = props.row.id;
          return (
            <div>  

              <span onClick={() => editOrDeleteGateway(rowIdx, "edit")}
                data-tooltip="Modifier" >
                <i className="far fa-edit action mr-2"></i>
              </span>
              <b>&emsp;</b>                                                    
              <span onClick={() => sendGatewayOrder(rowIdx, "change config")}
                  data-tooltip="Recharger table d'association device" >
                <i className="fa fa-file" aria-hidden="false"></i> 
              </span>                   
              <b>&emsp;</b>                                                    
              <span onClick={() => sendGatewayOrder(rowIdx, "upgrade firmware")}
                  data-tooltip="Mettre à jour le logiciel" >
                <i className="fa fa-upload"></i> 
              </span>
              <b>&emsp;</b>
              <span onClick={() => sendGatewayOrder(rowIdx, "reboot")}
                  data-tooltip="Redémarrer" >
                <i className="fas fa-power-off" aria-hidden="false"></i> 
              </span> 
              <b>&emsp;</b>                                  
              <span onClick={() => editOrDeleteGateway(rowIdx, "delete")}
                  data-tooltip="Supprimer" >
                <i className="fa fa-trash"></i>
              </span>
            </div>
          );
        },
      },
      { Header: "Statut", accessor: "action_status" },
    ],
    //eslint-disable-next-line
    []
  );
  }
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data: gateway_list,
  });

  return (
    <div>
      <Row>
        <Col sm={8} style = {{width:"50%"}}>
          <Row>
            <input
              type="text"
              className="form-control"
              placeholder="Recherche par numéro série"
              value={searchName}
              onChange={onChangeSearchName}
              style = {{width:"auto", maxWidth:"70%"}}
            />
            <button className="btn btn-outline-secondary" onClick={findGatewayByName} style={{width:"auto", maxWidth:"30%"}}>
              <Icon name='search' size='large' inverted color='black'/>
            </button>
          </Row>
        </Col>
        {(props.role !== "staff" && props.accountInformation.readOnly !== true) ?
        <Col sm={4} style={{ width: "50%", display: "flex", flexDirection: "row", justifyContent: "right"}}>
          <button className="btn btn-sm btn-success" onClick={manageAddNewGatewayDisplay} style={{ width: "100px", fontSize: "0.9em"}}>
            <FormattedMessage id="button.add" defaultMessage="Add" />
          </button>
        </Col>
          :
          null
        }
      </Row>
      <br/>
      <Row style={{ maxHeight:"65vh", overflowY: 'auto'}}>
        <table
          className="table table-striped table-bordered"
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </Row>  
      {display_Add_Gateway_Popup ? <AddGateway cancelPopup={manageAddNewGatewayDisplay} closeAfterAdd={closeAfterAdding} structure_Id={props.structure_Id}/> : null}
      {display_Edit_Gateway_Popup ? <Gateway cancelPopup={manageEditGatewayDisplay} closeAfterEdit={closeAfterEdition} id_gw={current_Id_Gtw} structure_Id={props.structure_Id}/> : null}
      {display_Delete_Gateway_Popup ? <DeleteObject cancelPopup={manageDeleteGatewayDisplay} closeAfterDelete={closeAfterDeletion} id={current_Id_Gtw} object_type={"gateway"} object_name={current_Name_Gtw} structure_Id={props.structure_Id}  reloadUserAndProfiles={props.reloadUserAndProfiles}/> : null}
      {display_Send_Gateway_Order_Popup ? <GatewayOrder cancelPopup={manageGatewayOrderDisplay} closeAfterUpgrade={closeAfterOrder} id={current_Id_Gtw} structure_Id={props.structure_Id} typeOfOrder={type_Of_Gtw_Order} gw_name={current_Name_Gtw}/> : null}
    </div>
  );
};

export default withStyles(Constants.styles)(GatewayList);
